import { ReactNode, useContext, createContext } from "react";
import { $staffApi } from "../api";
import { StaffApiSchema } from "@apiUtils/index";

export enum InstitutionType {
  CreditUnion = "credit_union",
  Bank = "bank",
}

type InstitutionContextType = {
  institution: StaffApiSchema.components["schemas"]["InstitutionContext"];
};

const InstitutionContext = createContext<InstitutionContextType | null>(null);

export function InstitutionContextProvider({ children }: { children: ReactNode }) {
  const { data: institution } = $staffApi.useSuspenseQuery("get", "/api/institution/");

  return (
    <InstitutionContext.Provider value={{ institution }}>{children}</InstitutionContext.Provider>
  );
}

export function useInstitutionContext() {
  const context = useContext(InstitutionContext);
  if (!context) throw new Error("useInstitution must be used within InstitutionProvider");

  const institutionType =
    context.institution.institution_type === "credit_union"
      ? InstitutionType.CreditUnion
      : InstitutionType.Bank;

  const customerOrMember = institutionType === InstitutionType.CreditUnion ? "member" : "customer";

  return { ...context, institutionType, customerOrMember };
}
